import VerifyIdentityPage from "./VerifyIdentityPage";

export default VerifyIdentityPage;
